define('home/views/NotificationsLoggedOutView',[
    'underscore',

    'home/views/NotificationsView',
    'home/views/NotificationCardLoginView',

], function (
    _,

    NotificationsView,
    NotificationCardLoginView
) {
    'use strict';

    var NotificationsLoggedOutView = NotificationsView.extend({
        templateHelpers: function () {
            var templateHelpers = NotificationsView.prototype.templateHelpers;
            return _.defaults({
                isLoggedOut: true,
            }, _.isFunction(templateHelpers) ? templateHelpers.call(this) : templateHelpers);
        },

        getTabView: function () {
            return new NotificationCardLoginView();
        },
    });

    return NotificationsLoggedOutView;
});

